import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../../LanguageSelector';
import useIsHomePage from '../../../../hooks/useIsHomePage';
import FacebookIcon from '../../../../icons/SocialIcons/Facebook';
import InstagramIcon from '../../../../icons/SocialIcons/Instagram';
import LinkedinIcon from '../../../../icons/SocialIcons/Linkedin';

import useStyles from '../makeStyles';

const BottomFooter = ({ handleChangeLanguage, language }) => {
  const classes = useStyles();
  const isHomePage = useIsHomePage();
  const { t } = useTranslation();

  return (
    <div className={cn({ [classes.bottomFooter]: !isHomePage })}>
      <div className={classes.bottomFooterContainer}>
        <div className={isHomePage ? classes.homePageLanguage : classes.language}>
          <LanguageSelector
            onLanguageChange={(value) => handleChangeLanguage(value)}
            selectedLanguage={language}
            withIcon
          />
        </div>
        <div className={isHomePage ? classes.homePageCopyRight : classes.copyRight}>
          {t('footer.copyRight')}
          &nbsp;
          {new Date().getFullYear()}
        </div>
        <div className={isHomePage ? classes.homePageSocialLinks : classes.socialLinks}>
          <div>
            <a href="https://www.facebook.com/efesinsurance" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </a>
          </div>
          <div>
            <a href="https://www.instagram.com/efes.insurance" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/efes-insurance" target="_blank" rel="noopener noreferrer">
              <LinkedinIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

BottomFooter.propTypes = {
  handleChangeLanguage: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
};

export default BottomFooter;
